import { render, staticRenderFns } from "./RequestAQuoteRules.vue?vue&type=template&id=358deb62"
import script from "./RequestAQuoteRules.vue?vue&type=script&lang=js"
export * from "./RequestAQuoteRules.vue?vue&type=script&lang=js"
import style0 from "./RequestAQuoteRules.vue?vue&type=style&index=0&id=358deb62&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wedevs/Herd/dokan-core/wp-content/plugins/dokan-pro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('358deb62')) {
      api.createRecord('358deb62', component.options)
    } else {
      api.reload('358deb62', component.options)
    }
    module.hot.accept("./RequestAQuoteRules.vue?vue&type=template&id=358deb62", function () {
      api.rerender('358deb62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "modules/request-for-quotation/assets/src/js/admin/pages/RequestAQuoteRules.vue"
export default component.exports